import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export default class extends Controller {
  static targets = ["form", "input", "submit", "button", "spinner"];

  connect() {
    this.resetForm();
  }

  show() {
    this.buttonTarget.classList.add("hidden");
    this.formTarget.classList.remove("hidden");
    this.inputTarget.focus();
  }

  cancel(event) {
    event?.preventDefault();
    this.resetForm();
  }

  resetForm() {
    this.formTarget.classList.add("hidden");
    this.buttonTarget.classList.remove("hidden");
    this.inputTarget.value = "";
    this.submitTarget.disabled = false;
    this.spinnerTarget.classList.add("hidden");
  }

  async submit(event) {
    event.preventDefault();
    if (this.inputTarget.value.trim() === "") return;

    this.setLoading(true);

    try {
      const response = await post(this.formTarget.action, {
        body: new FormData(this.formTarget),
      });

      if (response.ok) {
        this.resetForm();
      } else {
        console.error("Failed to create card");
      }
    } catch (error) {
      console.error("Error creating card:", error);
    } finally {
      this.setLoading(false);
    }
  }

  submitOnEnter(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      this.submit(event);
    }
  }

  setLoading(isLoading) {
    this.submitTarget.disabled = isLoading;
    this.spinnerTarget.classList.toggle("hidden", !isLoading);
  }
}
